import { render, staticRenderFns } from "./incl-catalogPageLayoutElement.vue?vue&type=template&id=4115d9bd&scoped=true"
import script from "./incl-catalogPageLayoutElement.vue?vue&type=script&lang=js"
export * from "./incl-catalogPageLayoutElement.vue?vue&type=script&lang=js"
import style0 from "./incl-catalogPageLayoutElement.vue?vue&type=style&index=0&id=4115d9bd&prod&scoped=true&lang=css"
import style1 from "./incl-catalogPageLayoutElement.vue?vue&type=style&index=1&id=4115d9bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115d9bd",
  null
  
)

export default component.exports